import * as Enumerable from 'linq';
import { EntityForm } from '../entities/entity.form/entity.form';
import { MetadataEntityFieldData } from '../metadata/entity/decorators/model/metadata.entity.field.data';
import { MetadataEntityFieldGroup } from '../metadata/entity/decorators/metadata.catalog';

export class EntityFormUtility {

    public static isValid(entityForm: EntityForm, fields: MetadataEntityFieldGroup[]) {

        const iFields = Enumerable.from(fields).selectMany(x => x.fields).where(x => !x.readonly);

        const optionFields = iFields.where(x => this.isInitOptionField(x)).toArray();
        const defaultFields = iFields.where(x => this.isDefaultField(x)).toArray();

        // Check if options field error

        const isValidRequiredField = Enumerable.from(optionFields)
            .all(x => {
                return Enumerable.from(entityForm.options)
                    .any(path => path === x.path)
            });


        // Check if default field error

        const defaultValue = entityForm.defaultValue ?? {};
        const isValidDefaultField = Enumerable.from(defaultFields)
            .any(x => {
                return !!defaultValue[x.path]
            });


        return isValidRequiredField && isValidDefaultField
    }

    public static getFieldOptions(options: string[], fields: MetadataEntityFieldGroup[]) {
        const flatFields = Enumerable.from(fields).selectMany(x => x.fields);

        const result = Enumerable.from(options).select(path => {
            return flatFields.singleOrDefault(x => x.path === path);
        }).where(x => !!x).toArray()

        return result;
    }

    public static isInitOptionField(field: MetadataEntityFieldData) {
        return field.webForm && field.required;
    }

    public static isDefaultField(field: MetadataEntityFieldData) {
        return !field.webForm && field.required;
    }

}